import React, { useEffect, useState } from 'react'
import { getBrowserAlertText } from "../../helper/helper";
import useAppContext from '../../context/useAppContext';
import { useLocation } from "react-router-dom";

const InvestAzHeader = ({ children }) => {
	const { innerTexts } = useAppContext();
    const [darkHeader, setDarkHeader] = useState(true)
    const browserAddress = useLocation();


    useEffect(() => {
      if(browserAddress?.pathname?.includes('register')) {
        setDarkHeader(false)
      }
    }, [browserAddress])

  return (
    <>
      <div className="bg" style={{ background: darkHeader ? '' : 'white' }}>
        <header>
          <div className="container">
            <div className="row">
              <div className="col-xs-7 col-sm-3 col-md-5">
                <a href="/" className="logo">
                  {/* <img src="/images/logo.svg" alt="logo" /> */}
                  ​<picture>
                    <source srcSet={darkHeader ? "/images/logo_light.svg" : "/images/logo.svg"} type="image/svg+xml"/>
                    <img style={{maxWidth: '100%', width: '15em'}} src={darkHeader ? "/images/logo_light.svg" : "/images/logo.png"} alt="logo"/>
                </picture>
                </a>
              </div>
              <div className="col-xs-5  col-sm-9 col-md-7">
                <div className="header_right">
                  <a href={`mailto:${innerTexts.companyEmail}`} className="hr_box" style={{ color: darkHeader ? 'white' : '#333132' }}>
                    <img src={darkHeader ? "/images/mail.svg" : "/images/mail_dark.svg"} alt="" />
                    {innerTexts.companyEmail}
                  </a>

                  <a href={innerTexts.companyPhoneLink} className="hr_box" style={{ color: darkHeader ? 'white' : '#333132' }}>
                    <img src={darkHeader ? "/images/phone.svg" : "/images/phone_dark.svg"} alt="" />
                    {innerTexts.companyPhone}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </header>
        {getBrowserAlertText() ? <div className="container-fluid information" style={{textAlign: "center"}}>
          {getBrowserAlertText()}
        </div> : null}
        {children}
      </div>
    </>
  )

}
export default InvestAzHeader
